import React from 'react'
import PropTypes from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import { WhiteSpace } from 'antd-mobile';


export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>
                    <WhiteSpace size='lg' />
                    <WhiteSpace size='lg' />
                    <Container maxWidth="lg">
                        <Grid container item xs={12} >
                            {children}
                        </Grid>
                    </Container>
                </>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};